import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import AuthService from "services/auth.services.js"; // Added missing import

export default function authChecking(){
    const auth = ( JSON.parse(localStorage.getItem(AuthService.verified_user)) != null ) ? true : null ;

    // If has token, return outlet in other case return navigate to login page

    return auth ? <Switch /> : <Redirect to="/auth/sign-in" />;
}
